/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
import {
	Badge,
	Card,
	CardHeader,
	CardFooter,
	DropdownMenu,
	DropdownItem,
	UncontrolledDropdown,
	DropdownToggle,
	Media,
	Pagination,
	PaginationItem,
	PaginationLink,
	Progress,
	Table,
	Container,
	Row,
	UncontrolledTooltip,
	Modal,
	ModalBody,
	ModalHeader,
	Form,
	Label,
	Input,
	Button,
	Col,
	Spinner,
	Dropdown,
} from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
// core components
import TagsInput from 'react-tagsinput';
import Header from '../../components/AdminHeader';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactQuill from 'react-quill';
import {
	addProduct,
	updateProduct,
	deleteProduct,
} from '../../Redux/actions/productActions';

const Tables = () => {
	const [productData, setProductData] = useState({
		name: '',
		composition: '',
		category: '',
		tags: [],
		imageURLID: '',
		featureProduct: false,
		prescription: '',
		description: '',
		value: 0,
		type: '',
	});
	const [typesOfPill, setTypesOfPill] = useState([
		{
			power: '',
			quantity: '',
			price_per_pills: '',
			our_price: '',
			_id: '',
		},
	]);
	const [tags, setTags] = useState([]);
	const tagsRef = useRef([]);
	const editTagsRef = useRef([]);
	const descriptionRef = useRef('');
	const editDescriptionRef = useRef('');
	const [limit, setLimit] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [addModal, setAddModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [id, setId] = useState('');
	const { allCategories } = useSelector(state => state.category);
	const { loading, allProducts } = useSelector(state => state.products);
	const dispatch = useDispatch();

	const addToggle = () => {
		setAddModal(!addModal);
	};

	const editToggle = () => {
		setEditModal(!editModal);
	};

	const deleteToggle = () => {
		setDeleteModal(!deleteModal);
	};

	const handleChange = e => {
		let { name, value } = e.target;
		setProductData({ ...productData, [name]: value });
	};
	const handleTypeChange = (e, index) => {
		let { name, value } = e.target;
		let duplicate = [...typesOfPill];
		duplicate[index][name] = value;
		setTypesOfPill(duplicate);
	};
	const handleTagsInput = tags => {
		setProductData({ ...productData, tags: tags });
	};
	const handleChangeDescription = html => {
		setProductData({ ...productData, description: html });
	};
	const handleAddClick = () => {
		setTypesOfPill([
			...typesOfPill,
			{
				power: '',
				quantity: '',
				price_per_pills: '',
				our_price: '',
				_id: '',
			},
		]);
	};
	const handleRemoveClick = index => {
		const duplicate = [...typesOfPill];
		duplicate.splice(index, 1);
		setTypesOfPill(duplicate);
	};
	return (
		<>
			<Header />
			{/* Page content */}
			<Container className='mt--7' fluid>
				{/* Add Modal */}
				<Modal isOpen={addModal} toggle={addToggle}>
					<ModalHeader>Add Product</ModalHeader>
					<ModalBody>
						<Form
							onSubmit={e => {
								e.preventDefault();
								for (let i = 0; i < typesOfPill.length; i++) {
									typesOfPill[i]['_id'] = uuidv4();
									typesOfPill[i].price_per_pills = Number(
										typesOfPill[i]['our_price'] /
											typesOfPill[i]['quantity']
									).toFixed(2);
								}

								let obj = { ...productData, typesOfPill };
								dispatch(addProduct(obj)).then(res => {
									addToggle();
									setProductData({
										name: '',
										composition: '',
										category: '',
										tags: [],
										imageURLID: '',
										featureProduct: false,
										prescription: '',
										description: '',
										value: 0,
										type: '',
									});
									setTypesOfPill([
										{
											power: '',
											quantity: '',
											price_per_pills: '',
											our_price: '',
											_id: '',
										},
									]);
								});
							}}
						>
							<Label>Name</Label>
							<Input
								type='text'
								name='name'
								onChange={handleChange}
								required
							/>
							<Label>Composition</Label>
							<Input
								type='text'
								name='composition'
								onChange={handleChange}
								required
							/>
							<Label>Category</Label>
							<div>
								<Input
									required
									className='form-control'
									type='select'
									onChange={e =>
										setProductData({
											...productData,
											category: e.target.value,
										})
									}
								>
									<option value=''>Select</option>
									{allCategories.map(category => (
										<option value={category.categoryName}>
											{category.categoryName}
										</option>
									))}
								</Input>
							</div>
							<Label>Tags</Label>
							<TagsInput
								ref={tagsRef}
								value={productData.tags}
								onChange={handleTagsInput}
							/>
							{/* <Input
								type='text'
								name='tag'
								onChange={handleChange}
								required
							/> */}
							<Label>Description</Label>
							<ReactQuill
								ref={descriptionRef}
								required
								// value={productData.description}
								onChange={handleChangeDescription}
							/>
							<Label>Value</Label>
							<Input
								type='number'
								name='value'
								onChange={handleChange}
								required
							/>
							<Label>Prescription</Label>
							<Input
								type='text'
								name='prescription'
								onChange={handleChange}
								required
							/>
							<Label>Type</Label>
							<Input
								type='text'
								name='type'
								onChange={handleChange}
								required
							/>
							<Label>Feature Product</Label>
							<Input
								type='checkbox'
								// name='type'
								className='ml-2'
								onChange={e =>
									setProductData({
										...productData,
										featureProduct: e.target.checked,
									})
								}
								// required
							/>
							<div>
								<Label>Types Of Pills</Label>
							</div>
							{typesOfPill.map((tp, index) => (
								<>
									<Row>
										<Col md='3'>
											<Label>Power</Label>
										</Col>
										<Col md='3'>
											<Label>Price</Label>
										</Col>
										<Col md='3'>
											<Label>Quantity</Label>
										</Col>
										<Col md='3'>
											{/* <Label>Quantity</Label> */}
										</Col>
									</Row>
									<Row>
										<Col md='3'>
											<Input
												type='text'
												name='power'
												onChange={e =>
													handleTypeChange(e, index)
												}
												required
											/>
										</Col>
										{/* <Label>Price</Label> */}
										<Col md='3'>
											<Input
												type='number'
												name='our_price'
												onChange={e =>
													handleTypeChange(e, index)
												}
												required
											/>
										</Col>
										{/* <Label>Quantity</Label> */}
										<Col md='3'>
											<Input
												type='number'
												name='quantity'
												onChange={e =>
													handleTypeChange(e, index)
												}
												required
											/>
										</Col>
										<Col md='3'>
											<div className='d-flex mt-2'>
												<Button
													onClick={handleAddClick}
													color='success'
													size='sm'
												>
													<i className='fas fa-plus' />
												</Button>
												<Button
													onClick={() =>
														handleRemoveClick(index)
													}
													color='danger'
													size='sm'
													disabled={
														typesOfPill.length < 2
													}
												>
													<i className='fas fa-minus' />
												</Button>
											</div>
										</Col>
									</Row>
								</>
							))}
							<div>
								<Label>Image</Label>
							</div>
							<Input
								type='file'
								// name='name'
								onChange={e =>
									setProductData({
										...productData,
										imageURLID: e.target.files[0],
									})
								}
								required
							/>
							<div className='d-flex my-2'>
								<Button
									onClick={() => {
										addToggle();
										setTypesOfPill([
											{
												power: '',
												quantity: '',
												price_per_pills: '',
												our_price: '',
												_id: '',
											},
										]);
									}}
									className='ml-auto'
									color='danger'
								>
									Cancel
								</Button>
								<Button
									color='primary'
									className='float-right'
									type='submit'
								>
									{loading ? <Spinner /> : 'Add'}
								</Button>
							</div>
						</Form>
					</ModalBody>
				</Modal>
				{/* Edit Modal */}
				<Modal
					isOpen={editModal}
					toggle={() => {
						editToggle();
						setProductData({
							name: '',
							composition: '',
							category: '',
							tags: [],
							imageURLID: '',
							featureProduct: false,
							prescription: '',
							description: '',
							value: 0,
							type: '',
						});
						setTypesOfPill([
							{
								power: '',
								quantity: '',
								price_per_pills: '',
								our_price: '',
								_id: '',
							},
						]);
					}}
				>
					<ModalHeader>Edit Product</ModalHeader>
					<ModalBody>
						<Form
							onSubmit={e => {
								e.preventDefault();
								let obj = { ...productData, typesOfPill };
								dispatch(updateProduct(id, obj)).then(res => {
									editToggle();
									setProductData({
										name: '',
										composition: '',
										category: '',
										tags: [],
										imageURLID: '',
										featureProduct: false,
										prescription: '',
										description: '',
										value: 0,
										type: '',
									});
									setTypesOfPill([
										{
											power: '',
											quantity: '',
											price_per_pills: '',
											our_price: '',
											_id: '',
										},
									]);
								});
							}}
						>
							<Label>Name</Label>
							<Input
								type='text'
								name='name'
								value={productData.name}
								onChange={handleChange}
								// required
							/>
							<Label>Composition</Label>
							<Input
								type='text'
								name='composition'
								value={productData.composition}
								onChange={handleChange}
								// required
							/>
							<Label>Tag</Label>
							<TagsInput
								// ref={editTagsRef}
								value={productData.tags}
								onChange={handleTagsInput}
							/>
							<Label>Description</Label>
							<ReactQuill
								ref={editDescriptionRef}
								required
								value={productData.description}
								onChange={handleChangeDescription}
							/>
							{/* <Input
								type='text'
								name='tag'
								onChange={handleChange}
								value={productData.tag}
								// required
							/> */}
							<Label>Value</Label>
							<Input
								type='number'
								name='value'
								onChange={handleChange}
								value={productData.value}
								// required
							/>
							<Label>Prescription</Label>
							<Input
								type='text'
								name='prescription'
								onChange={handleChange}
								value={productData.prescription}
								// required
							/>
							<Label>Type</Label>
							<Input
								type='text'
								name='type'
								onChange={handleChange}
								value={productData.type}
								// required
							/>
							<Label>Feature Product</Label>
							<Input
								type='checkbox'
								// name='type'
								checked={productData.featureProduct}
								className='ml-2'
								onChange={e =>
									setProductData({
										...productData,
										featureProduct: e.target.checked,
									})
								}
								// required
							/>
							<div>
								<Label>Types Of Pills</Label>
							</div>
							{typesOfPill.map((tp, index) => (
								<>
									<Row>
										<Col md='3'>
											<Label>Power</Label>
										</Col>
										<Col md='3'>
											<Label>Price</Label>
										</Col>
										<Col md='3'>
											<Label>Quantity</Label>
										</Col>
										<Col md='3'>
											{/* <Label>Quantity</Label> */}
										</Col>
									</Row>
									<Row>
										<Col md='3'>
											<Input
												type='text'
												name='power'
												value={tp.power}
												onChange={e =>
													handleTypeChange(e, index)
												}
												// required
											/>
										</Col>
										{/* <Label>Price</Label> */}
										<Col md='3'>
											<Input
												type='number'
												name='our_price'
												value={tp.our_price}
												onChange={e =>
													handleTypeChange(e, index)
												}
												// required
											/>
										</Col>
										{/* <Label>Quantity</Label> */}
										<Col md='3'>
											<Input
												type='number'
												name='quantity'
												value={tp.quantity}
												onChange={e =>
													handleTypeChange(e, index)
												}
												// required
											/>
										</Col>
										<Col md='3'>
											<div className='d-flex mt-2'>
												<Button
													onClick={handleAddClick}
													color='success'
													size='sm'
												>
													<i className='fas fa-plus' />
												</Button>
												<Button
													onClick={() =>
														handleRemoveClick(index)
													}
													color='danger'
													size='sm'
													disabled={
														typesOfPill.length < 2
													}
												>
													<i className='fas fa-minus' />
												</Button>
											</div>
										</Col>
									</Row>
								</>
							))}
							<div className='d-flex my-2'>
								<Button
									onClick={() => {
										editToggle();
										setProductData({
											name: '',
											composition: '',
											category: '',
											tags: [],
											imageURLID: '',
											featureProduct: false,
											prescription: '',
											description: '',
											value: 0,
											type: '',
										});
										setTypesOfPill([
											{
												power: '',
												quantity: '',
												price_per_pills: '',
												our_price: '',
												_id: '',
											},
										]);
									}}
									className='ml-auto'
									color='danger'
								>
									Cancel
								</Button>
								<Button
									color='primary'
									className='float-right'
									type='submit'
								>
									Edit
								</Button>
							</div>
						</Form>
					</ModalBody>
				</Modal>
				{/* Delete modal */}
				<Modal isOpen={deleteModal} toggle={deleteToggle}>
					<ModalHeader>Delete Product</ModalHeader>
					<ModalBody>
						<div>
							<span>Are you sure you want to delete</span>
						</div>
						<div className='d-flex'>
							<Button
								className='ml-auto'
								onClick={deleteToggle}
								color='danger'
							>
								Cancel
							</Button>
							<Button
								onClick={() => {
									dispatch(deleteProduct(id)).then(res => {
										deleteToggle();
									});
								}}
								className='float-right'
								color='success'
							>
								Delete
							</Button>
						</div>
					</ModalBody>
				</Modal>

				{/* Dark table */}
				<Row className='mt-5'>
					<div className='col'>
						<Card className='bg-default shadow'>
							<CardHeader className='bg-transparent border-0'>
								<div className='d-flex'>
									<h3 className='text-white mb-0'>
										Products
									</h3>
									<Button
										onClick={addToggle}
										color='primary'
										className='ml-auto'
									>
										Add Product
									</Button>
								</div>
							</CardHeader>
							<Table
								className='align-items-center table-dark table-flush'
								responsive
							>
								<thead className='thead-dark'>
									<tr>
										<th scope='col'>Name</th>
										<th scope='col'>Category</th>
										<th scope='col'>Value</th>
										<th scope='col'>Types of Pills</th>
										{/* <th scope='col'>Completion</th> */}
										<th scope='col' />
									</tr>
								</thead>
								<tbody>
									{allProducts &&
										allProducts.map((ap, index) => (
											<tr key={ap.id}>
												<th scope='row'>
													<Media className='align-items-center'>
														<a
															className='avatar rounded-circle mr-3'
															href='#pablo'
															onClick={e =>
																e.preventDefault()
															}
														>
															<img
																alt='...'
																src={
																	ap.imageURLID
																}
															/>
														</a>
														<Media>
															<span className='mb-0 text-sm'>
																{ap.name}
															</span>
														</Media>
													</Media>
												</th>
												<td>{ap.category}</td>
												<td>
													<Badge
														color=''
														className='badge-dot mr-4'
													>
														<i className='bg-warning' />
														{ap.value}
													</Badge>
												</td>

												<td className=''>
													{ap.typesOfPill.map(tp => (
														<Badge color='danger'>
															{tp.quantity} pills
															for ${tp.our_price}
														</Badge>
													))}
												</td>
												<td>
													<Button
														onClick={() => {
															setProductData({
																name: ap.name,
																composition:
																	ap.composition,
																category:
																	ap.category,
																tags: ap.tags,
																featureProduct:
																	ap.featureProduct,
																prescription:
																	ap.prescription,
																value: ap.value,
																type: ap.type,
																description: ap.description
															});
															setTypesOfPill(
																ap.typesOfPill
															);
															setId(ap.id);
															editToggle();
														}}
														size='sm'
													>
														<i className='fas fa-edit' />
													</Button>
													<Button
														onClick={() => {
															setId(ap.id);
															deleteToggle();
														}}
														size='sm'
													>
														<i className='fas fa-trash' />
													</Button>
												</td>
											</tr>
										))}
								</tbody>
							</Table>
							{/* <CardFooter className='bg-transparent border-0 py-4'>
								<nav aria-label='...'>
									<Pagination
										className='pagination justify-content-end mb-0'
										listClassName='justify-content-end mb-0'
									>
										<PaginationItem
											disabled={currentPage == 1}
										>
											<PaginationLink
												href='#pablo'
												onClick={e =>
													e.preventDefault()
												}
												tabIndex='-1'
											>
												<i className='fas fa-angle-left' />
												<span className='sr-only'>
													Previous
												</span>
											</PaginationLink>
                    </PaginationItem>
                    {}
										<PaginationItem className='active'>
											<PaginationLink
												href='#pablo'
												onClick={e =>
													e.preventDefault()
												}
											>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink
												href='#pablo'
												onClick={e =>
													e.preventDefault()
												}
											>
												2{' '}
												<span className='sr-only'>
													(current)
												</span>
											</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink
												href='#pablo'
												onClick={e =>
													e.preventDefault()
												}
											>
												3
											</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink
												href='#pablo'
												onClick={e =>
													e.preventDefault()
												}
											>
												<i className='fas fa-angle-right' />
												<span className='sr-only'>
													Next
												</span>
											</PaginationLink>
										</PaginationItem>
									</Pagination>
								</nav>
							</CardFooter> */}
						</Card>
					</div>
				</Row>
			</Container>
		</>
	);
};

export default Tables;
